import Vue from "vue";

export default Vue.extend({
  template: `
    <a href="#" @click.stop.prevent="targetDialog" class="font-weight-bold subtitle-1">
        {{value}}
    </a>`,
  data() {
    return {
      value: null
    };
  },
  mounted() {
    this.value = this.params.value;
  },
  methods: {
    targetDialog() {
      this.params.context.componentParent.openTargetDialog(this.params.data);
    }
  }
});